// extracted by mini-css-extract-plugin
export var active = "Tabs-module--active--74f32";
export var background = "Tabs-module--background--d242a";
export var callout = "Tabs-module--callout--0bb28";
export var center = "Tabs-module--center--a64b0";
export var content = "Tabs-module--content--62790";
export var cta = "Tabs-module--cta--f998f";
export var ctaButton = "Tabs-module--cta-button--d28f6";
export var ctaImage = "Tabs-module--cta-image--f0914";
export var eyebrow = "Tabs-module--eyebrow--3e04b";
export var footerCta = "Tabs-module--footer-cta--c8e39";
export var icon = "Tabs-module--icon--4b6e1";
export var navWrapper = "Tabs-module--nav-wrapper--0af54";
export var tab = "Tabs-module--tab--ea787";
export var tabButton = "Tabs-module--tab-button--ef7ee";
export var tabButtons = "Tabs-module--tab-buttons--79a9c";
export var tabs = "Tabs-module--tabs--51f57";